﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import { headerComponents } from './header';
import TKManager from '@tk/basics/tk.manager';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKFormRangeslider from '@tk/controls/tk.form.rangeslider';
import TKSelection from '@tk/controls/tk.selection';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';
import { configureStore } from '@tk/utilities/tk.use.store';
import TKHeadingNav from '@tk/components/tk.heading.nav';
import TKFileLink from '@tk/components/tk.file.link';
import TKLightGallery from '@tk/components/tk.light.gallery';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/struct.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Struct extends TKModuleFactory {
    constructor() {
        super([
            ...headerComponents,
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-form-range-slider', constructor: TKFormRangeslider },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-heading-nav', constructor: TKHeadingNav },
            { name: 'tk-file-link', constructor: TKFileLink },
            { name: 'tk-light-gallery', constructor: TKLightGallery },
        ]);
    }
}

new Struct();
